import { render, staticRenderFns } from "./SimpleHome.vue?vue&type=template&id=d6d049da"
import script from "./SimpleHome.vue?vue&type=script&lang=js"
export * from "./SimpleHome.vue?vue&type=script&lang=js"
import style0 from "./SimpleHome.vue?vue&type=style&index=0&id=d6d049da&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports